<template>
  <div>
    <pxkeji-rightHeader />

    <div class="pxkeji-right-box">
      <!-- <pxkeji-btn name="ceshi" type="primary" size="large" roles="设备新增,设备编辑"  icon="search"  />  -->

      <a-form class="ant-advanced-search-form">
        <a-row :gutter="24">
          <a-col :span="8">
            <a-form-item label="用户信息">
              <a-input placeholder="用户名/姓名/身份证号/手机号" v-model="where.keyword.number" />
            </a-form-item>
          </a-col>
          <a-col :span="4">
                <a-form-item label="用户组">
                    <a-select
                            show-search
                            v-model="where.keyword.groupId"
                            :filter-option="filterOption"
                            allowClear
                            @change="groupChanged"
                    >
                        <a-select-option
                                :value="info.id"
                                v-for="(info, index) in grouplist"
                                :key="index"
                        >{{info.name}}
                        </a-select-option>
                    </a-select>
                </a-form-item>
            </a-col>
            <a-col :span="10">
                <a-form-item label="所在地区">
                    <a-cascader
                            :options="areas"
                            placeholder="请选择所在地区"
                            change-on-select
                            @change="onAreachange"
                            :default-value="areaList"
                            :fieldNames="{ label: 'name', value: 'name', children: 'children' }"
                    />
                </a-form-item>
            </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="6">
                <a-form-item label="充值时间">
                    <a-range-picker
                            format="YYYY-MM-DD"
                            :placeholder="['开始时间', '结束时间']"
                            @change="onTimeChange"
                    />
                </a-form-item>
          </a-col>
          <a-col :span="6">
              <a-form-item label="单位名称">
                  <a-input placeholder="请输入" v-model="where.keyword.company"/>
              </a-form-item>
          </a-col>
          <a-col :span="6">
                <a-form-item label="充值方式">
                    <a-select
                            show-search
                            v-model="where.keyword.body"
                            :filter-option="filterOption"
                            allowClear>
                        <a-select-option value="购物消费">购物消费</a-select-option>
                        <a-select-option value="线下充值">线下充值</a-select-option>
                    </a-select>
                </a-form-item>
            </a-col>
          <a-col :span="6" :style="{ textAlign: 'right' }">
            <a-button type="primary" @click="searchList" v-btnlimit="'充值管理-搜索'">搜索</a-button>
            <!-- <a-button :style="{ marginLeft: '8px' }" @click="clear">清空</a-button> -->
            <!-- <a :style="{ marginLeft: '8px', fontSize: '12px' }" @click="toggle">
              {{ expand?"闭合":"高级搜索" }}
              <a-icon :type="expand ? 'up' : 'down'"/>
            </a>-->
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="pxkeji-right-box">
      <pxkeji-btn name="导出" class="pxkeji_basic_btn" @click="exportList" v-btnlimit="'充值管理-导出'"/>
       <pxkeji-btn
        name="充值"
        class="pxkeji_basic_btn"
        v-btnlimit="'充值管理-充值'"
        @click="showInfo(0)"
        type="primary"
      />
<!--      <pxkeji-btn name="批量导出" v-if="selectRows.length>0" class="pxkeji_basic_btn" />-->
      <pxkeji-btn
        name="批量启用"
        v-if="selectRows.length>0"
        v-btnlimit="'充值管理-批量启用'"
        class="pxkeji_basic_btn"
        @click="batchEnable"
      />
      <pxkeji-btn
        name="批量禁用"
        v-if="selectRows.length>0"
        v-btnlimit="'充值管理-批量禁用'"
        class="pxkeji_basic_btn"
        @click="batchDisEnable"
      />

      <a-alert type="info" showIcon style="margin-bottom:20px">
        <span slot="message">
          已选择 {{selectRows.length}} 项
          <a
            @click="clearRows"
            style="color: #1890ff;margin-left:10px"
          >清空</a>
        </span>
      </a-alert>

      <a-table
        :columns="list.columns"
        rowKey="id"
        :pagination="list.pagination"
        @change="onChange"
        :dataSource="list.datas"
        :loading="isloading"
        :rowSelection="{type:'checkbox',onChange:onRowChange,selectedRowKeys:selectRows}"
        :locale="{emptyText:'暂无数据'}"
      >
        <span slot="count" slot-scope="count">
          <span v-if="count==-1">不限</span>
          <span v-else>{{count}}</span>
        </span>
        <span slot="status" slot-scope="status">
          <a-tag v-if="status" color="green">已启用</a-tag>
          <a-tag v-else color="red">已禁用</a-tag>
        </span>
        <span slot="action" slot-scope="action">
          <pxkeji-btn
            name="编辑"
            :roles="['专家-编辑']"
            @click="showInfo(action.id,action)"
            size="small"
            type="primary"
          />
        </span>
      </a-table>
    </div>

    <a-modal
      :title="addedit.title"
      v-model="addedit.visible"
      width="1000px"
      :footer="false"
      destroyOnClose
      :maskClosable="false"
    >
      <Info @callbackMethod="save" :id="addedit.id" :infos="addedit.info" />
    </a-modal>
  </div>
</template>
<script>
var that;
import Info from "./chargeInfo.vue"; //新增编辑

const columns = [
  {
    dataIndex: "id",
    key: "id",
    align: "center",
    title: "记录编号"
  },
  {
    dataIndex: "userName",
    key: "userName",
    align: "center",
    title: "姓名"
  },
   /* {
        dataIndex: "telephone",
        key: "telephone",
        align: "center",
        title: "手机号"
    },*/
  {
    dataIndex: "count",
    key: "count",
    align: "center",
    title: "充值金额"
  },
  {
    dataIndex: "body",
    key: "body",
    align: "center",
    title: "充值方式"
  },
  {
    dataIndex: "addTime",
    key: "addTime",
    align: "center",
    title: "充值时间"
  },
  // {
  //   dataIndex: "status",
  //   key: "status",
  //   align: "center",
  //   title: "支付状态",
  //   scopedSlots: { customRender: "status" }
  // },
  // {
  //   title: "操作",
  //   key: "action",
  //   align: "center",
  //   scopedSlots: { customRender: "action" }
  // }
];

export default {
  name: "couponlist",
  data() {
    return {
      expand: false, //高级搜索
      // 2021 09 28 start
        areas:[],
        areaList: [],
        grouplist: [],
        //2021 09 28 end
      list: {
        columns, //表头
        datas: [], //数据
        pagination: {
          //分页器
          showQuickJumper: true,
          hideOnSinglePage: true,
          total: 0,
          current: 1, //页码
          defaultPageSize: 10 //页容
        }
      },
      addedit: {
        title: "",
        info: {},
        id: 0,
        visible: false
      },
      where: {
        //查询条件
        keyword: {
          //搜索条件
          number: "",
          name: "",
          status: "",
          // 2021 09 28 start
            groupId:"", 
            province:'',
            city:'',
            area:'',
            // 2021 11 01 start
            body:'',
            company:'',
            startTime: "",
            endTime: "",
            // 2021 11 01 end
            // 2021 09 28 end
        }
      },
      selectRows: [], //选中项编号
      isloading: false,
      visible: false //弹框
    };
  },
  components: {
    Info: Info
  },
  mounted: function() {
    this.$nextTick(function() {
      that = this;
      this.GetList();
      this.getgrouplist();//2021 09 28
        this.getarea(); //2021 09 28
    });
  },
  watch: {
    selectRows: function() {
      //console.log("watch", val);
    }
  },
  methods: {
    // 2021 11 08 start
      /**导出 */
      exportList() {
        window.location.href = this.$api.recharge.exportList(
                        this.where.keyword.number,
                        this.where.keyword.province,
                        this.where.keyword.city,
                        this.where.keyword.area,
                        this.where.keyword.groupId,
                        this.where.keyword.body,
                        this.where.keyword.company,
                        this.where.keyword.startTime,
                        this.where.keyword.endTime,
        );
      },
      // 2021 11 08 end
    // 2021 09 28 start
      onAreachange(v){
            if(v[0]){
              this.where.keyword.province=v[0];
            }else{
              this.where.keyword.province='';
            }
            if(v[1]){
              this.where.keyword.city=v[1];
            }else{
              this.where.keyword.city='';
            }
            if(v[2]){
              this.where.keyword.area=v[2];
            }else{
              this.where.keyword.area='';
            }
        },
      getarea(){
          this.areas=this.$api.city.city;
      },
      getgrouplist() {
            this.isloading = true;
            this.$api.usergroup
                .getAll()
                .then(res => {
                    this.isloading = false;
                    if (res.errorCode == this.$msg.responseCode.success) {
                        this.grouplist = res.data;
                    } else {
                        this.error(res.errorMsg);
                    }
                })
                .catch(() => {
                    this.isloading = false;
                    this.error();
                });
        },
        // 2021 10 22 start
    filterOption(input, option) {
     return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    // 2021 10 22 end
      // 2021 09 28 end
    toggle() {
      this.expand = !this.expand;
    },
    GetList() {
      //获取列表
      this.isloading = true;
      this.clearRows();
      this.$api.recharge
              .getPageList(
          this.list.pagination.current,
          this.list.pagination.defaultPageSize,
          (this.where.keyword.number==""?null:this.where.keyword.number),
          this.where.keyword.province,
          this.where.keyword.city,
          this.where.keyword.area,
          this.where.keyword.groupId,
          this.where.keyword.body,
          this.where.keyword.company,
          this.where.keyword.startTime,
          this.where.keyword.endTime,
        )
        .then(res => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.list.datas = res.data.records;
            this.list.pagination.total = res.data.total;
          } else {
            that.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    onTimeChange(date, dateString) {
      this.where.keyword.startTime = dateString[0];
      this.where.keyword.endTime = dateString[1];
    },
    onChange(page) {
      //页面切换回调
      this.list.pagination.current = page.current;
      this.GetList();
    },
    onRowChange(selectedRowKeys) {
      //table 多选
      this.selectRows = selectedRowKeys;
    },
    clearRows() {
      //清空选中项
      this.selectRows = [];
    },
    searchList() {
      this.list.pagination.current = 1;
      this.GetList();
    },
    clear() {
      //清空搜索条件
      for (var info in this.where.keyword) {
        this.where.keyword[info] = "";
      }
    },
    showInfo(id, info) {
      //打开弹出框
      this.addedit.visible = true;
      this.addedit.title = id ? "编辑" : "新增";
      this.addedit.id = id;
      this.addedit.info = info;
    },
    /*批量启用 */
    batchEnable() {
      this.handleProhibit(this.selectRows.join(","), 1);
    },
    /*批量禁用 */
    batchDisEnable() {
      this.$confirm({
        title: "您确定要执行批量禁用的操作吗?",
        okText: "确定",
        okType: "danger",
        cancelText: "我再想想",
        onOk() {
          that.handleProhibit(that.selectRows.join(","), 0);
        },
        onCancel() {}
      });
    },
    /*禁用启用 */
    handleProhibit(ids, status) {
      that.isloading = true;
      that.$api.operation.coupon
        .updateBatchById(ids, status)
        .then(res => {
          that.isloading = false;
          if (res.errorCode == that.$msg.responseCode.success) {
            that.$message.success(res.errorMsg);
            that.GetList();
          } else {
            that.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          that.isloading = false;
        });
    },
    /**删除 */
    delInfo(id) {
      this.$confirm({
        title: "您确定要删除此项吗?",
        okText: "确定",
        okType: "danger",
        cancelText: "我再想想",
        onOk() {
          that.isloading = true;
          that.$api.operation.coupon
            .removeById(id)
            .then(res => {
              that.isloading = false;
              if (res.errorCode == that.$msg.responseCode.success) {
                that.$message.success(res.errorMsg);
                that.GetList();
              } else {
                that.$message.error(res.errorMsg);
              }
            })
            .catch(() => {
              that.isloading = false;
            });
        },
        onCancel() {}
      });
    },
    /**发券 */
    giveCoupon(id) {
      this.issuing.visible = true;
      this.issuing.id = id;
    },
    /**明细 */
    voidCoupon(id) {
      this.voids.visible = true;
      this.voids.id = id;
    },
    save() {
      this.addedit.visible = false;
      this.GetList();
    }
  }
};
</script>

<style>
.ant-advanced-search-form .ant-form-item {
  display: flex;
}

.ant-advanced-search-form .ant-form-item-control-wrapper {
  flex: 1;
}

#components-form-demo-advanced-search .ant-form {
  max-width: none;
}

#components-form-demo-advanced-search .search-result-list {
  margin-top: 16px;
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: #fafafa;
  min-height: 200px;
  text-align: center;
  padding-top: 80px;
}
</style>

